import { AuthModal } from 'containers/Auth/AuthModal'
import { useAuth } from 'contexts/AuthContext'
import { useState } from 'react'
import { Wrapper } from 'styles/styleSystem/wrapper'

interface LoggedInActionProps {
  message?: string
  children: React.ReactNode
  action?: any
  wrapperStyle?: any
}

/**
 * Wrapper for actions that require user to be logged in
 * @param message - the warning message displayed in the login form, relating to the action
 * @param action - the function that the child fires if logged in
 */

export const LoggedInAction: React.FC<LoggedInActionProps> = ({
  message = 'You need to be logged in to perform this action',
  children,
  action,
  wrapperStyle = null,
}) => {
  const { isLoggedIn } = useAuth()
  const [authModalOpen, setAuthModalOpen] = useState(false)

  const handleClick = (e) => {
    e.stopPropagation()
    // Change this to isLoggedIn... currently this is easier for testing
    if (!action) return

    if (isLoggedIn) {
      action()
    } else {
      setAuthModalOpen(true)
    }
  }

  return (
    <Wrapper onClick={handleClick} {...wrapperStyle}>
      {children}
      <AuthModal
        message={message}
        isOpen={authModalOpen}
        setOpen={setAuthModalOpen}
      />
    </Wrapper>
  )
}
